// @ts-nocheck
import { createTheme, alpha } from '@mui/material/styles';
import _ from 'lodash';
import baseTheme from './nimbusBaseTheme';

// The palette enables you to modify the color of the components to suit your brand.
// https://material-ui.com/customization/palette/
// https://material-ui.com/customization/default-theme/?expand-path=$.palette
// export default createTheme({
//   ...baseTheme,
//   themeName: 'Nimbus Light',
// });

// NOTE: Do not use any const or let in the theme file. It will break the theme object.

const LIGHT_THEME = {
  themeName: 'Nimbus Light',
  palette: {
    mode: 'light',
    type: 'light',
    primary: {
      main: '#272D55',
    },
    secondary: {
      main: '#AECDFC',
    },
    success: {
      light: '#52BE7F',
      main: '#058234',
      dark: '#1B7943',
      contrastText: '#000000',
      successTask: '#25AF60',
    },
    error: {
      main: '#EB5757',
      light: '#EF7878',
      dark: '#A43C3C',
      contrastText: '#FFFFFF',
    },
    warning: {
      main: '#D08329',
      light: '#FBBE76',
      dark: '#AF793A',
      contrastText: '#000000',
    },
    info: {
      main: '#D08329',
      light: '#FBBE76',
      dark: '#AF793A',
      contrastText: '#000000',
    },
    divider: '#CACACA',
    other: {
      appBar: '#FFFFFF',
      sidebar: '#FFFFFF',
      sidebarMenuHover: '#F0F0F0',
      sidebarMenuSelected: '#e3e3e3',
      listTableHeaderBg: 'transparent',
      listTableCellBorder: '#CACACA',
      tableBorder: '#CACACA',
      scrollbarThumb: '#CACACA',
      listTableRowSelectedBg: '#F0F0F0',
      tableCellHoverBg: '#F0F0F0',
      outlineColor: '#000000',
      multipleDeleteSnackBarBg: '#3A3D54',
      bordergreyColor: '#8F8F8F',

      ipynbInputBg: '#edededed',
      ipynbOutputBg: '#FFFFFF',

      flowcardBackgroundColor: '#edededed',

      blue2: '#F3F5FF',
      blue3: '#C8DEFF',
      blue4: '#645fe4',
      blue5: '#5890ff',

      blue6: '#1890FF1A',
      blue7: '#E3ECFF',

      brandBlue: '#272D55',
      userChatColor: '#EDEDED',
      badgeColor: '#EFCCBE',
      badgeBorder: '#EE883D',
      badgeText: '#FFFFFF',
      badgeFocusColor: '#ddd',
      operationNode: '#EF9A60',
      lightBrandBlueLogin: '#84AFEF',
      documentationMenuBarBg: '#FFFFFF',
      hover: '#E8F1FF',
      white: '#FFFFFF',
      white2: '#ddd',
      black: '#000000',
      grey1: '#F4F4F4',
      grey2: '#9396AA',
      gray3: '#E5E8FA',
      purple: '#963DEE',
      yellow: '#B88A14',
      yellow2: '#FFC444',
      pink: '#B6205F',
      grey3: '#666',
      grey4: '#999',
      grey5: '#BCBCBC',
      grey6: '#636363',
      grey7: '#DFE1EE',

      grey9: '#393939',
      pieChart1: '#EBF0B1',
      pieChart2: '#EE9023',
      pieChart3: '#ACB9FD',
      pieChart4: '#BDEDDA',
      pieChart5: '#F4B2B6',
      pieChart6: '#AAD6FF',
      pieChart7: '#F9BCE4',
      pieChart8: '#FFD3B4',
      pieChart9: '#A6DCFB',
      pieChart10: '#B3F0F0',
      pieChart11: '#EBF0B1',
      pieChart12: '#D4BCF2',
      pieChart13: '#FDE5AA',
      pieChart14: '#EDB777',
      barChart1: '#DEF0B8',
      barChart2: '#BDEDDA',
      barChart3: '#B3F0F0',
      barChart4: '#F4B2B6',
      loginSecondaryColor: '#DFE7F3',
      gradient1:
        'linear-gradient(90deg, rgba(243,245,255,1) 0%, rgba(200,222,255,1) 79%)',
      gradient2:
        'linear-gradient(269.82deg, rgb(221, 233, 255) 57.25%, rgba(200, 222, 255, 0.1) 230.71%)',
      tableRowGradient1:
        'linear-gradient(269.82deg, rgb(221, 233, 255) 1.25%, rgba(200, 222, 255, 0.1) 102.71%)',
      tableRowGradient2:
        'linear-gradient(269.82deg, rgb(221, 233, 255) 57.25%, rgba(200, 222, 255, 0.1) 230.71%)',
      green: '0BB7A7',
      green1: '#3cf4ff',
      green2: '#00DD92',
      red: '#FF1809',
      red2: '#FF1414',
      carouselButton: '#3EEEFE',
      flowCard: '#F2F7FF',
      errorLabel: '#C21919',
      timeSpentChart1: '#336699',
      timeSpentChart2: '#228B22',
      timeSpentChart3: '#B22222',
      timeSpentChart4: '#FF8C00',
      timeSpentChart5: '#6A5ACD',
      timeSpentChart6: '#20B2AA',
      timeSpentChart7: '#8B4513',
      timeSpentChart8: '#9400D3',
      timeSpentChart9: '#F15B50',
      timeSpentChart10: '#008080',
      timeSpentChart11: '#B8860B',
      timeSpentChart12: '#FF1493',
      editorOptionFocus: '#E5E5E5',
      editorBorderColor: '#C7C7C7',
      editorBackgroundColor: '#FFFFFF',
    },
    text: {
      primary: '#282828',
      disabled: '#9396AA',
      contrastText: '#1A1A1A',
      placeholder: '#525252',
      inactiveTab: '#434343',
      toolbarOption: '#595959',
    },
    background: {
      default: '#F9F9F9',
    },
    monacoColors: {
      foreground: '#1A1A1A',
      background: '#F5F6FA',
      lineNumber: '#181F4B',
      gutterBackground: '#E6EEFC',
      selection: '#CCE0FF',
      cursor: '#000000',
      identifier: '#1A1A1A',
      number: '#0041A8',
      comment: '#4D4D4D',
      keyword: '#7600DD',
      string: '#9A3737',
      activeLineNumber: '#000000',
      foldingControl: '#333333',
      scrollbar: '#A0B8D9',
      dropdownBorder: '#000000',
      bracketMatchBackground: '#FFE564',
      suggestBackground: '#FFFFFF',
      suggestSelected: '#DCEEFF',
      suggestBorder: '#B3B3B3',
      error: '#CC0000',
      warning: '#E69500',
      info: '#007ACC',
      hint: '#008060',
      ruler: '#999999',
      whitespace: '#CCCCCC',
      indentGuide: '#CCCCCC',
      indentGuideActive: '#7F7F7F',
    },
    loginPage: {
      background: '#ffffff',
      loginFormBorder: '#E5E7EB',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          '&::-webkit-scrollbar-thumb': {
            background: '#CACACA',
          },
        },
        '.ProseMirror pre': {
          backgroundColor: '#141A3F',
          color: '#f6f1f1',
        },
        '.ProseMirror .wrapperDiv-placeholder': {
          backgroundColor: '#F3F5FF',
          color: '#1A1A1A !important',
        },
        '.ProseMirror .placeholder-decoration': {
          color: '#ffffff',
          backgroundColor: ' #272D55',
        },
        '.ProseMirror .selected-cell-decoration': {
          backgroundColor: 'rgba(227, 236, 255, 1)',
          borderColor: ' #272D55',
        },
        '.ProseMirror table': {
          borderColor: '#84AFEF',
        },
        '.tiptap table td.selectedCell': {
          backgroundColor: '#dfdfdf !important',
        },
        '.tiptap table th.selectedCell': {
          backgroundColor: '#dfdfdf !important',
          color: '#000 !important',
        },
        '.menuBarTiptap .is-active': {
          backgroundColor: '#E5E5E5',
        },
        'img.ProseMirror-selectednode': {
          borderColor: '#272D55',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
        },
      },
    },

    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
        },
      },
    },

    MuiDialog: {
      styleOverrides: {
        paper: {
          // backgroundColor: '#F3F5FF',
          // boxShadow: '0px 6px 12px rgba(132, 175, 239, 0.31)',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: alpha('#AECDFC', 0.5),
        },
        colorSecondary: {
          borderColor: '#84AFEF',
        },
        root: {
          '&:hover': {
            backgroundColor: '#AECDFC',
          },
          '&:focus': {
            backgroundColor: '#AECDFC',
          },
          '&:focus-visible': {
            outlineColor: '#000000',
          },
          '&.job-queue-chip-active': {
            backgroundColor: alpha('#AECDFC', 0.5),
          },
          '&.job-queue-chip': {
            backgroundColor: '#FFFFFF',
          },
        },
        label: {
          color: '#272D55',
        },
        deleteIconColorPrimary: {
          color: '#272D55',
          '&:hover': {
            color: '#272D55',
          },
        },
      },
    },

    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: '#272D55 !important',
          '&.list-table-header': {
            backgroundColor: '#E3E3E3 !important',
            color: '#282828 !important',

            '& .MuiCheckbox-root': {
              color: '#272D55',
            },
            '& .Mui-checked': {
              color: '#272D55',
            },
            '& .MuiTableSortLabel-root': {
              backgroundColor: 'transparent',
              '& svg': {
                fill: '#272D55 !important',
              },
            },
          },
        },

        root: {
          background: '#FFFFFF',
          '&.MuiTablePagination-root': {
            background: 'transparent',
          },
          '&.list-table-cell': {},
        },
        sizeMedium: {
          '&.list-table-cell': {
            borderColor: '#CACACA',
          },
        },

        sizeSmall: {
          borderColor: '#CACACA',
          '&:hover': {
            backgroundColor: '#F0F0F0',
          },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          borderColor: '#272D55',
          '& .MuiTableSortLabel-root': {
            backgroundColor: 'transparent',
            '& svg': {
              fill: '#FFFFFF !important',
            },
          },

          '&.MuiTableHead-bg th': {
            borderTop: '1px solid',
            backgroundColor: '#272D55 !important',

            '&:hover': {
              backgroundColor: '#272D55 !important',
            },
          },
        },
      },
    },
    MuiTableSortLabel: {
      styleOverrides: {
        icon: {
          color: '#AECDFC !important',
        },
      },
    },
    MuiTableBody: {
      styleOverrides: {
        root: {
          borderColor: '#CACACA',
        },
      },
    },

    MuiTablePagination: {
      styleOverrides: {
        root: {
          '& .MuiTablePagination-toolbar': {
            background: '#F9F9F9 !important',

            '& select': {
              background: 'transparent',
            },
          },
        },
        select: {
          // background: '#FFFFFF',
          '&:focus-visible': {
            outlineColor: '#000000',
          },
        },
        actions: {
          '& button:focus-visible': {
            outlineColor: '#000000',
          },
        },
        toolbar: {
          // background: '#F3F5FF',
        },
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        previousNext: {
          background: '#FFFFFF !important',
        },
        root: {
          '&:focus-visible': {
            outlineColor: '#000000 !important',
          },
        },
      },
    },

    MuiLinearProgress: {
      styleOverrides: {
        barColorPrimary: {
          backgroundColor: '#272D55 !important',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: '#393939 !important',
          '&.Mui-focused': {
            color: '#393939 !important',
          },
          '&.Mui-error': {
            color: '#C21919 !important',
          },
          '&.Mui-disabled': {
            color: '#9396AA !important',
          },
        },
      },
    },

    MuiFormControl: {
      styleOverrides: {
        root: {
          '& .MuiInputLabel-root': {
            color: '#000',
            '&.Mui-error': {
              color: '#C21919 !important',
            },
            '& .MuiTypography-root': {
              color: '#000',
            },
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputLabel-root': {
            color: '#393939',
          },
          '& .MuiInputLabel-shrink': {
            color: '#000',
          },
          '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline':
            {
              borderColor: 'rgba(0, 0, 0, 0.38)',
            },
        },
      },
    },
    MuiBox: {
      styleOverrides: {
        root: {
          backgroundColor: 'none',
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          borderColor: '#CACACA',
          // '& .Mui-selected': {
          //   color: '#141A3F !important',
          // },
        },

        indicator: {
          boxShadow: '0px -2px 14px rgba(39, 45, 85, 0.24)',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          color: '#AAACBB',
        },
      },
    },
    // MuiButton: {
    // 	styleOverrides: {
    // 		outlinedSizeLarge: {
    // 			color: '#AECDFC !important',
    // 		},
    // 		containedSecondary: {
    // 			color: '#141A3F !important',
    // 		},
    // 	},
    // },
    MuiIconButton: {
      styleOverrides: {
        root: {
          '&:focus-visible': {
            outlineColor: '#000000',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          '&:focus-visible': {
            outlineColor: '#000000',
          },
          '&.Mui-SearchPaginationAction': {
            backgroundColor: '#272D55',
            color: '#FFFFFF',
            '&:hover': {
              backgroundColor: '#1B1F3B',
            },
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: '#272D55',
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#272D55',
          '&.Mui-focusVisible': {
            backgroundColor: '#D9D9D9',

            '& .MuiSvgIcon-root': {
              backgroundColor: 'white',
            },
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        track: {
          '&.Mui-checked': {},
        },
        thumb: {
          borderColor: '#272D55 !important',
          '&.Mui-checked': {
            backgroundColor: '#272D55 !important',
          },
        },
        input: {
          '&:focus-visible + .MuiSwitch-thumb': {
            outlineColor: '#000000',
          },
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          borderBottomColor: '#84AFEF',
          '& .MuiListItemButton-root': {
            '& .list-item-button-hover-actions-right': {
              backgroundImage:
                'linear-gradient(269.82deg, #DDE9FF 68.25%, rgba(200, 222, 255, 0.1) 87.71%)',
            },
            '&:hover': {
              backgroundColor: '#C8DEFF',
            },
          },
        },
      },
    },

    MuiSelect: {
      styleOverrides: {
        select: {
          backgroundColor: '#ffffff ',
        },
        icon: {
          color: '#272D55 !important',
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          color: '#393939',
          '&.Mui-error': {
            color: '#C21919',
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: '#C21919',
          '&.Mui-error': {
            color: '#C21919',
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderColor: '#BCBCBC !important',
          backgroundColor: '#FFFFFF !important',
          '& fieldset': {
            border: 'none',
          },
          '&:hover': {
            borderColor: '#BCBCBC !important',
          },
          '&.Mui-focused': {
            borderColor: '#141E62 !important',
          },
          '&.Mui-error': {
            borderColor: '#C21919 !important',
            '& .MuiFormHelperText-root': {
              color: '#C21919 !important',
            },
          },
          '&.Mui-disabled': {
            color: '#E9E9E9 !important',
          },
        },
        input: {
          color: '#393939 !important',
          '&::placeholder': {
            color: '#525252 !important',
            opacity: 1,
          },
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF !important',
        },
      },
    },
    MuiSlider: {
      styleOverrides: {
        root: {
          color: '#272D55',
        },
        track: {
          backgroundColor: '#272D55',

          borderColor: '#272D55',
        },
        rail: {
          backgroundColor: '#FFFFFF',

          borderColor: '#272D55',
        },
        valueLabel: {
          color: '#FFFFFF',
          background: '#272D55',
        },
        mark: {
          background: '#272D55 !important',
        },
        markLabel: {
          color: '#272D55 !important',
        },
        thumb: {
          '&:hover': {
            boxShadow: `0px 0px 0px 15px ${alpha('#AECDFC', 0.5)} !important`,
          },
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          backgroundColor: alpha('#AECDFC', 0.4),
          '&.permission-accordion': {
            backgroundColor: alpha('#AECDFC', 0.1),
          },

          '&:before': {
            backgroundColor: 'transparent !important',
          },
          '&.job-queue-accordion': {
            borderColor: '#BCBCBC',
            '& .MuiAccordionDetails-root': {
              backgroundColor: 'transparent',
            },
          },
          '&.job-queue-accordion-read': {
            backgroundColor: '#FFFFFF',
          },
          '&.job-queue-accordion-unread': {
            backgroundColor: alpha('#AECDFC', 0.2),
          },
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          background: '#272D55',
          color: '#FFFFFF !important',
          '& .MuiTypography-root': {
            color: '#FFFFFF !important',
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&:hover': '#e3e3e3',
        },
      },
    },
  },
};

export default createTheme(_.merge(_.cloneDeep(baseTheme), LIGHT_THEME));
